//React
import * as React from 'react';
import parse from 'html-react-parser';

//MUI
import Slider from '@mui/material/Slider';

import { DateContext } from './DateContext';
import DateFilter from './DateFilter';

function SliderWidget({sSystemName, cMake})
{
    let systemConfig = require('../config/' + sSystemName + '.json');
    let systemCSS = require('../config/' + sSystemName + '.css');

    const [sliderPosition, setSliderPosition] = React.useState(0);
    const { withinDate, setWithinDate } = React.useContext(DateContext);

    const eventSliderMoved = (event, newPosition) => {
        setSliderPosition(newPosition);
    };

    const cSliderCSS = {
        position: "absolute",
        left: "10%",
        width: "80%",
        bottom: "0.5%"
    };

    function fRenderSlide(cMake, iSlide) {
        let slideHtml = cMake.acSlides[iSlide].asHtml.join("");
    
        // Extract and update iframe URL
        const iframeRegex = /<iframe[^>]+src=['"]([^'"]+)['"]/;
        const match = slideHtml.match(iframeRegex);
    
        if (match && match[1]) {
            const [baseUrl, hashFragment] = match[1].split("#");
            let updatedUrl = `${baseUrl}${baseUrl.includes("?") ? "&" : "?"}within_date=${encodeURIComponent(withinDate)}`;
            if (hashFragment) updatedUrl += `#${hashFragment}`;
            slideHtml = slideHtml.replace(match[1], updatedUrl);
        }
    
        return (
            <div key={iSlide} style={{ flex: 1, boxSizing: 'border-box' }}>
                {parse(slideHtml)}
            </div>
        );
    }
    

    function fRenderSlides(cMake, iStart) {
        if (acMarks.length === 0) {
            for (let i = 0; i < cMake.acSlides.length; i++) {
                const label = cMake.iDisplaySlides === 1 ? i : cMake.acSlides[i].sTitle;
                acMarks.push({ value: i, label: <span style={{ fontWeight: 'bold' }}>{label}</span> });
            }
        }
    
        const slides = [];
        for (let i = iStart; i < iStart + cMake.iDisplaySlides && i < cMake.acSlides.length; i++) {
            slides.push(fRenderSlide(cMake, i));
        }
    
        return (
            <div style={{ display: 'flex', width: '100%', height: '90%' }}>
                {slides}
            </div>
        );
    }
    

    const acMarks = [];

    const bShowSlider = cMake.acSlides.length > 1;

    return (
        <div
    id={"widget_slider_" + cMake.sName}
    style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      boxSizing: 'border-box',
    }}
  >
    <div className="slider-widget-filter-bar">
  <DateFilter />
</div>
           
            
    <div style={{ flex: 1, overflow: 'hidden' }}>
      {fRenderSlides(cMake, sliderPosition)}
    </div>

        {bShowSlider && (
            <Slider 
                aria-label="Small steps"
                style={cSliderCSS}
                defaultValue={0}
                step={1}
                marks={acMarks}
                valueLabelDisplay="off"
                min={0}
                max={cMake.acSlides.length - 1}
                onChange={eventSliderMoved}
            />
        )}
        </div>
    );
}

export default SliderWidget